import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl/dist';
import classNames from 'classnames';

// Components

import GridItem from './GridItem';
import SecuredFormattedMessageWrapper from '../../../../../lib/wrappers/SecuredFormattedMessageWrapper';

// Utils

import { appendClassNames } from '../../../../../utils/miscellaneous/appendClassNames';



const IncomeItem = props => {

    let {
        id,
        amount,
        design,
        frequency,
        sourceName,
        type,
        replacements = {},
        incomeStartDate,
        incomeEndDate,
        isStrikeThroughValue = false
    } = props;

    const strikeText = value  => {
        return isStrikeThroughValue
            ? (
                <span className = { isStrikeThroughValue ? 'text-strike-review' : '' }>
                    {value}
                </span>
            )
            : value;
    };

    const internationalize = (value = '') => {
        switch(true) {
            case ['ssap.', 'common.'].some(v => typeof value === 'string' && value.includes(v)):
                return strikeText(<FormattedMessage id={value}/>);
            default:
                return strikeText(value);
        }
    };

    replacements = {
        ...replacements,
        ...(replacements.frequency ? { frequency:<FormattedMessage id={replacements.frequency }/> } : {})
    };

    const mergeConditionallyToArray = (indicator, payload) => {

        if(indicator !== undefined) {
            switch(true){
                case Array.isArray(payload):
                    return payload;
                default: return [ payload ];
            }
        } else {
            return [];
        }
    };

    const incomeItemClassName = classNames(
        'grid-row margin-y-1 review-document-content review-document',
        { 'design': !!design }
    );

    return (
        <div
            className = { incomeItemClassName }
            data-automation-id={id && id}
        >
            <GridItem
                items={[
                    {
                        value: (
                            <Fragment>
                                <span className={design ? '' : 'bold item-newline'}>
                                    <SecuredFormattedMessageWrapper>
                                        { strikeText(<FormattedMessage id={type}/>) }
                                    </SecuredFormattedMessageWrapper>
                                </span>
                                {
                                    sourceName && strikeText(
                                        <Fragment>
                                            <span>
                                                ({ sourceName })
                                            </span>
                                        </Fragment>
                                    )
                                }
                            </Fragment>
                        ),
                        className: appendClassNames('', design)
                    },
                    {
                        value: internationalize(amount),
                        className: appendClassNames('', design)
                    },
                    {
                        value: strikeText(
                            <SecuredFormattedMessageWrapper>
                                <FormattedMessage id={frequency} values={{ ...replacements }}/>
                            </SecuredFormattedMessageWrapper>
                        ),
                        className: appendClassNames('', design)
                    },
                    ...mergeConditionallyToArray(
                        incomeStartDate,
                        {
                            value: internationalize(incomeStartDate),
                            className: appendClassNames('', design)
                        }
                    ),
                    ...mergeConditionallyToArray(
                        incomeEndDate,
                        {
                            value: internationalize(incomeEndDate),
                            className: appendClassNames('', design)
                        }
                    )
                ]}
            />
        </div>
    );
};

export default IncomeItem;